(function () {
	$(".js-form-loader").load('szb-subscription-form.php', function(){
		initAvastForm();  
	});
})();